import React from 'react';
import DatePicker from 'react-datepicker';
import './Picker.scss';
import FontAwesomeIcon from '../Icon';

const Picker = ({ label, required, ...props }) => (
  <div className="picker">
    {label && (
      <div className="picker__label">{label}{ required && (
        <div className="picker__required" />
      )}</div>
    )}
    <div className="picker__datepicker">
      <div className="picker__icon">
        <FontAwesomeIcon
          glyph={props.showTimeSelect ? 'clock' : 'calendar'}
          weight='light'
        />
      </div>
      <div className="picker__chevron">
        <FontAwesomeIcon
          glyph='chevron-down'
          weight='light'
        />
      </div>
      <DatePicker
        dateFormat="MM/dd/yyyy"
        {...props}
        onFocus={(e) => e.target.readOnly = true}
        popperPlacement="top-start"
      />
    </div>
  </div>
);

export default Picker;
